import { useMemo } from 'react';
import { useEffectOnce } from 'react-use';
import useSWR from "swr"

const fetcher = (url) => fetch(url).then((res) => res.json());

export const useTaxonomies = ({
    endpoint = window.location.origin,
} = {}) => {
    const key = useMemo(() =>
        `${endpoint}/wp-json/wp/v2/taxonomies?per_page=100&_embed&context=embed`,
        [endpoint]
    )
    // useSWR to fetch the post types
    const { data: taxonomyData, error, mutate } = useSWR(
        key,
        fetcher,
        {
            revalidateOnFocus: false, // don't revalidate on focus
            revalidateOnReconnect: false, // don't revalidate on reconnect
            refreshInterval: 0, // don't refresh
            onFailure() {
                localStorage.removeItem(key)
            },
            onSuccess(taxonomies) {
                console.log(taxonomies)
                localStorage.setItem(key, JSON.stringify(taxonomies));
            }
        }
    )

    const isTaxonomiesLoading = useMemo(() => !taxonomyData && !error, [taxonomyData, error]);
    const isTaxonomiesError = useMemo(() => error && !taxonomyData, [error, taxonomyData]);

    useEffectOnce(() => {
        // get data from localStorage
        const data = localStorage.getItem(key);
        if (data) {
            mutate(JSON.parse(data), false)
        }
    })

    return {
        taxonomyData,
        isTaxonomiesLoading,
        isTaxonomiesError,
    }
}

export default useTaxonomies